import React from 'react';
import styles from './style.scss';

const DotLoader = props => {
    return (
        <div className={styles['loader']}>
            <div className={styles['dot1']} />
            <div className={styles['dot2']} />
            <div className={styles['dot3']} />
        </div>
    )
};

export default DotLoader;